import * as React from "react";
import Select from "react-select";
import { FEES_TYPE_OPTIONS, isMergeBillType, isSingleBillType, isValidEmailField, normalizeFeeAmountDisplay, SINGLE_BILL_DETAIL_OPTIONS } from "../../utils/loginBillingUtils";

type LoginBillingFieldsProps = {
  state: any;
  required: boolean;
  handleChange: (e: any, propName?: string, fieldType?: string) => void;
  hideLoginFees?: boolean;
  loginFeesLabel?: string;
};

const LoginBillingFields: React.FC<LoginBillingFieldsProps> = ({
  state,
  required,
  handleChange,
  hideLoginFees = false,
  loginFeesLabel = "Login Fees",
}) => {
  const billTypes = state.billTypes || [];
  const lawhandsBranches = state.lawhandsBranches || [];
  const showLhBranch = isMergeBillType(billTypes, state.bill_type_id);
  const showSingleBillDetail = isSingleBillType(billTypes, state.bill_type_id);

  const billTypeOptions = billTypes.map((opt: any) => ({
    ...opt,
    label: opt.name,
    value: opt.id,
  }));

  const branchOptions = lawhandsBranches.map((opt: any) => ({
    ...opt,
    label: opt.name,
    value: opt.id,
  }));

  const getEmailClass = (value: string) => {
    if (required && value && !isValidEmailField(value)) {
      return "form-control is-invalid";
    }
    return "form-control";
  };

  return (
    <>
      <div className="col-md-12">
        <h6 className="mt-2 mb-1">Fees Details</h6>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Bill Type<span style={{ color: "red" }}>*</span></label>
          <Select
            options={billTypeOptions}
            name="bill_type_id"
            className={!state.bill_type_id ? "form-select is-invalid" : "form-select"}
            value={billTypeOptions.find((o: any) => String(o.value) === String(state.bill_type_id)) || null}
            onChange={(e) => handleChange(e, "bill_type_id", "singleselect")}
          />
          <div className="invalid-feedback">*Required Field</div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Fees Type<span style={{ color: "red" }}>*</span></label>
          <Select
            options={FEES_TYPE_OPTIONS}
            name="fees_type"
            className={!state.fees_type ? "form-select is-invalid" : "form-select"}
            value={FEES_TYPE_OPTIONS.find((o) => o.value === state.fees_type) || null}
            onChange={(e) => handleChange(e, "fees_type", "singleselect")}
          />
          <div className="invalid-feedback">*Required Field</div>
        </div>
      </div>
      {showSingleBillDetail && (
        <div className="col-md-6">
          <div className="form-group">
            <label>Common Bill & Location Wise Bill<span style={{ color: "red" }}>*</span></label>
            <Select
              options={SINGLE_BILL_DETAIL_OPTIONS}
              name="single_bill_detail"
              className={!state.single_bill_detail ? "form-select is-invalid" : "form-select"}
              value={SINGLE_BILL_DETAIL_OPTIONS.find((o) => o.value === state.single_bill_detail) || null}
              onChange={(e) => handleChange(e, "single_bill_detail", "singleselect")}
            />
            <div className="invalid-feedback">*Required when Bill Type is Single Bill</div>
          </div>
        </div>
      )}
      {showLhBranch && (
        <div className="col-md-6">
          <div className="form-group">
            <label>
              Bill Merged to - LH Branch<span style={{ color: "red" }}>*</span>
              <span className="inputEgMsg">Eg. Salem, Coimbatore</span>
            </label>
            <Select
              options={branchOptions}
              name="lh_branch"
              className={!state.lh_branch ? "form-select is-invalid" : "form-select"}
              value={branchOptions.find((o: any) => String(o.value) === String(state.lh_branch)) || null}
              onChange={(e) => handleChange(e, "lh_branch", "singleselect")}
            />
            <div className="invalid-feedback">*Required when Bill Type is Merge Bill</div>
          </div>
        </div>
      )}
      <div className="col-md-6">
        <div className="form-group">
          <label>
            Bill Send To
            <span className="inputEgMsg">Eg. bank@mail.com; support@mail.com; & etc</span>
          </label>
          <textarea
            className={getEmailClass(state.bill_receive_to_mail || "")}
            placeholder="Ex - billing@bank.com"
            name="bill_receive_to_mail"
            rows={3}
            value={state.bill_receive_to_mail || ""}
            onChange={(e) => handleChange(e)}
          />
          <div className="invalid-feedback">Invalid email format</div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>
            CC Mail
            <span className="inputEgMsg">Eg. bank@mail.com; support@mail.com; & etc</span>
          </label>
          <textarea
            className={getEmailClass(state.cc_mail || "")}
            placeholder="Ex - cc@bank.com"
            name="cc_mail"
            rows={3}
            value={state.cc_mail || ""}
            onChange={(e) => handleChange(e)}
          />
          <div className="invalid-feedback">Invalid email format</div>
        </div>
      </div>
      {!hideLoginFees && (
        <div className="col-md-6">
          <div className="form-group">
            <label>{loginFeesLabel}<span style={{ color: "red" }}>*</span></label>
            <input
              className={!state.login_fees ? "form-control is-invalid" : "form-control"}
              placeholder="Enter amount"
              name="login_fees"
              type="text"
              value={state.login_fees || ""}
              onChange={(e) => handleChange(e)}
            />
            <div className="invalid-feedback">*Required Field</div>
          </div>
        </div>
      )}
      {/* EC Service Charge and CC Service Charge hidden from forms; kept in reports only
      <div className="col-md-6">
        <div className="form-group">
          <label>EC Service Charge</label>
          <input
            className="form-control"
            placeholder="Enter amount"
            name="ec_service_charge"
            type="text"
            value={state.ec_service_charge || ""}
            onChange={(e) => handleChange(e)}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>CC Service Charge</label>
          <input
            className="form-control"
            placeholder="Enter amount"
            name="cc_service_charge"
            type="text"
            value={state.cc_service_charge || ""}
            onChange={(e) => handleChange(e)}
          />
        </div>
      </div>
      */}
      <div className="col-md-6">
        <div className="form-group">
          <label>Mutation Service Charge</label>
          <input
            className="form-control"
            placeholder="Enter amount"
            name="mutation"
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={normalizeFeeAmountDisplay(state.mutation)}
            onChange={(e) => handleChange(e)}
          />
        </div>
      </div>
    </>
  );
};

export default LoginBillingFields;
